import { ContextMenu, ContextMenuDeleteItem, ContextMenuItem, useHasPermission } from "@dgs/core";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { PermissionName } from "../../../../../shared/types/permission";

interface Props {
	onEdit: () => void;
	deleteEvent: () => void;
	duplicateEvent: () => void;
}

export const OverviewContextMenu: FC<Props> = ({ onEdit, deleteEvent, duplicateEvent }) => {
	const { t } = useTranslation();

	const canCreate = useHasPermission<PermissionName>(["event.create"]);
	const canUpdate = useHasPermission<PermissionName>(["event.update"]);
	const canDelete = useHasPermission<PermissionName>(["event.delete"]);

	return (
		<ContextMenu hideIconOnOnlyShortcuts={true} displayShortcutsAs="icon">
			{canUpdate && (
				<ContextMenuItem
					action={onEdit}
					title={t("Edit event")}
					label={t("Edit event")}
					icon="edit"
					shortcut="primary"
				/>
			)}
			{canCreate && (
				<ContextMenuItem
					action={duplicateEvent}
					title={t("Duplicate event")}
					label={t("Duplicate event")}
					icon="copy"
				/>
			)}
			{canDelete && (
				<ContextMenuDeleteItem
					action={deleteEvent}
					title={t("Archive event")}
					label={t("Archive event")}
					heading={t("Archive event")}
					labels={{ close: t("Close"), confirm: t("Confirm") }}
				>
					{t("Are you sure you want to archive this event?")}
				</ContextMenuDeleteItem>
			)}
		</ContextMenu>
	);
};
